namespace $ { $mol_style_attach( "shm/hitalama/map/widget/float/posts/posts.view.css",
 "[shm_hitalama_map_widget_posts] a {\n\tcolor: var(--mol_theme_control);\n}\n"
) }